export default "__VITE_ASSET__YiukJU5f__"